/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Groups_AvailableInputs */

const en_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No groups available`)
};

const fr_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun groupe disponible`)
};

const de_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Gruppen verfügbar`)
};

const it_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun gruppo disponibile`)
};

const ru_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группы недоступны`)
};

const es_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay grupos disponibles`)
};

const zh_cn2_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无分组`)
};

const ja_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なグループはありません`)
};

const hi_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई समूह उपलब्ध नहीं है`)
};

const pt_pt2_team_manager_no_groups_available = /** @type {(inputs: Team_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há grupos disponíveis`)
};

/**
* | output |
* | --- |
* | "No groups available" |
*
* @param {Team_Manager_No_Groups_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_groups_available = /** @type {((inputs?: Team_Manager_No_Groups_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Groups_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_no_groups_available(inputs)
	if (locale === "de") return de_team_manager_no_groups_available(inputs)
	if (locale === "it") return it_team_manager_no_groups_available(inputs)
	if (locale === "ru") return ru_team_manager_no_groups_available(inputs)
	if (locale === "es") return es_team_manager_no_groups_available(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_no_groups_available(inputs)
	if (locale === "ja") return ja_team_manager_no_groups_available(inputs)
	if (locale === "hi") return hi_team_manager_no_groups_available(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_no_groups_available(inputs)
	return en_team_manager_no_groups_available(inputs)
});